// Tag for graphql format
const gql = String.raw;

// Fragments
import { BonusesTiersFragment, CommissionsTiersFragment } from "@PayPlans/api/fragments/commons";

const GrossBonusOptionsFragment = gql`
	fragment GrossBonusOptions on GrossBonusOptions {
		bodyShop
		parts
		service
	}
`;

const GrossBonusFragment = gql`
	fragment GrossBonus on GrossBonus {
		make
		dealerCodeFS
		grossOptions {
			...GrossBonusOptions
		}
		frequency
		tiers {
			...BonusesTiers
		}
		applyTiersRetroactively
	}
	${BonusesTiersFragment}
	${GrossBonusOptionsFragment}
`;

const GrossDepartmentalFragment = gql`
	fragment GrossDepartmental on GrossDepartmental {
		makes {
			...GrossBonus
		}
		combineOEMs
		isGuaranteedDraw
	}
	${GrossBonusFragment}
`;

const OperatingCostsMakeFragment = gql`
	fragment OperatingCostsMake on OperatingCostsMake {
		_id
		make
		dealerCodeFS
		frequency
		tiers {
			...CommissionsTiers
		}
		applyTiersRetroactively
	}
	${CommissionsTiersFragment}
`;

const OperatingCostsFragment = gql`
	fragment OperatingCosts on OperatingCosts {
		makes {
			...OperatingCostsMake
		}
		combineOEMs
	}
	${OperatingCostsMakeFragment}
`;

export { GrossDepartmentalFragment, OperatingCostsFragment };
